import globals from '@descope-ui/theme-globals';
import { AvatarClass } from './component/AvatarClass';
import { getThemeRefs } from '@descope-ui/common/theme-helpers';

const globalRefs = getThemeRefs(globals);
const compVars = AvatarClass.cssVarList;

const avatar = {
  [compVars.hostDirection]: globalRefs.direction,
  [compVars.editableIconColor]: globalRefs.colors.surface.dark,
  [compVars.editableBorderColor]: globalRefs.colors.surface.dark,
  [compVars.editableBackgroundColor]: globalRefs.colors.surface.main,
  [compVars.avatarTextColor]: globalRefs.colors.surface.main,
  [compVars.avatarBackgroundColor]: globalRefs.colors.surface.dark,

  _editable: {
    [compVars.cursor]: 'pointer',
  },

  size: {
    xs: {
      [compVars.hostWidth]: '30px',
      [compVars.hostHeight]: '30px',
    },
    sm: {
      [compVars.hostWidth]: '40px',
      [compVars.hostHeight]: '40px',
    },
    md: {
      [compVars.hostWidth]: '60px',
      [compVars.hostHeight]: '60px',
    },
    lg: {
      [compVars.hostWidth]: '98px',
      [compVars.hostHeight]: '98px',
    },
    xl: {
      [compVars.hostWidth]: '120px',
      [compVars.hostHeight]: '120px',
    },
    '2xl': {
      [compVars.hostWidth]: '140px',
      [compVars.hostHeight]: '140px',
    },
  },
};

export default avatar;

export const vars = {
  ...compVars,
};
